import bdServicesExt from './bd-servicesExt'
import bdServices from './bd-services'
import bdServices125 from './bd-services125'
var FormData = require('form-data')
import 'regenerator-runtime'

const authServices = {}
const currentUrl = window.location.hostname
const url_local = process.env.API_LOCAL

authServices.signin = async function (usuario, pass) {
  let formData = new FormData()
  formData.append('user', usuario)
  formData.append('pass', pass)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/usuarios/auth.php'
  }

  const data = await bdServices(options)
    .then(res => res.data[0])
    .catch((err) => {
      console.error(err)
    })
  return data
}

authServices.verificacion = async function (usuario, pass) {
  return bdServices.get(`/SCA_Tuxpan/data/validacion.php?usuario=${usuario}&pass=${pass}`)
    .then(res => res.data)
    .catch(e => console.log(e))
}

authServices.registrarAcceso = async function (fecha, usuario) {
  let formData = new FormData()
  formData.append('fecha', fecha)
  formData.append('usuario', usuario)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    // url: '/addRecepcion.php'
    url: '/servidores/usuarios/addLogs.php'
  }
  return bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
  })

}

authServices.checkBloqueo = async function (user) {
  let formData = new FormData()
  formData.append('u', user)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/usuarios/blocked.php'
  }

  return bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
}

authServices.bloquearUser = async function (user, fecha_desbloqueo) {
  let formData = new FormData()
  formData.append('u', user)
  formData.append('f', fecha_desbloqueo)

  const options = {
    method: 'POST',
    headers: { 'content-type': 'application/form-data' },
    data: formData,
    url: '/servidores/usuarios/bloquearUser.php'
  }

  return bdServices(options)
    .then(res => res.data)
    .catch((err) => {
      console.error(err)
    })
}

export default authServices



// WEBPACK FOOTER //
// ./src/services/auth.js